module.exports = __webpack_public_path__ + "src/assets/images/volums/sound/volum_circle6.png?adca9c773702af5876980ef992cfba10";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/sound/volum_circle6.png
// module id = 685
// module chunks = 0